import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import _addDays from 'date-fns/addDays';
import addMinutes from 'date-fns/addMinutes';
import formatFunction from 'date-fns/format';
import _parse from 'date-fns/parse';
import _parseISO from 'date-fns/parseISO';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
var DateUtils = {
  format: function format(date, _format) {
    if (_format) {
      return formatFunction(date, _format);
    }

    return date;
  },
  parse: function parse(dateString, format, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$referenceDate = _ref.referenceDate,
        referenceDate = _ref$referenceDate === void 0 ? new Date() : _ref$referenceDate,
        timezone = _ref.timezone;

    var date = _parse(dateString, format, referenceDate);

    if (!timezone) {
      return date;
    }

    return utcToZonedTime(date, timezone);
  },
  parseISO: function parseISO(dateString, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        timezone = _ref2.timezone;

    var date = _parseISO(dateString);

    if (!timezone) {
      return date;
    }

    return utcToZonedTime(date, timezone);
  },
  getCurrentDate: function getCurrentDate(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        format = _ref3.format;

    return this.format(new Date(), format);
  },
  getTimezoneAwareNow: function getTimezoneAwareNow(timezone, _temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        format = _ref4.format;

    var currentDate = this.getCurrentDate();

    if (!timezone) {
      return this.format(currentDate, format);
    }

    var currentTimezoneDate = utcToZonedTime(currentDate, timezone);
    return this.format(currentTimezoneDate, format);
  },
  addDays: function addDays(days, _temp5) {
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        _ref5$date = _ref5.date,
        date = _ref5$date === void 0 ? new Date() : _ref5$date,
        format = _ref5.format;

    return this.format(_addDays(date, days), format);
  },
  parseHourInt: function parseHourInt(hourInt, _temp6) {
    var _ref6 = _temp6 === void 0 ? {} : _temp6,
        _ref6$referenceDate = _ref6.referenceDate,
        referenceDate = _ref6$referenceDate === void 0 ? new Date() : _ref6$referenceDate;

    if (!hourInt && typeof hourInt !== 'number') {
      return Number.NaN;
    }

    var normalizedHourInt = hourInt === 2400 ? 0 : hourInt;
    var timeString = normalizedHourInt.toString().padStart(4, '0');
    return _parse(timeString, 'HHmm', referenceDate);
  },
  getIsoDayOfWeek: function getIsoDayOfWeek(date, _temp7) {
    var _ref7 = _temp7 === void 0 ? {} : _temp7,
        format = _ref7.format; // monday = 1, sunday = 7


    var dateObject = format ? _parse(date, format, new Date()) : date;
    return +this.format(dateObject, 'i');
  },
  isNowBetweenDates: function isNowBetweenDates(startTime, endTime, _temp8) {
    var _ref8 = _temp8 === void 0 ? {} : _temp8,
        timezone = _ref8.timezone;

    var now = this.getTimezoneAwareNow(timezone);
    var startDate = !_isEmpty(startTime) && this.parseISO(startTime, {
      timezone: timezone
    });
    var endDate = !_isEmpty(endTime) && this.parseISO(endTime, {
      timezone: timezone
    });
    return (_isEmpty(startTime) || startDate < now) && (_isEmpty(endTime) || now < endDate);
  },
  intervalsBetweenHoursInt: function intervalsBetweenHoursInt(startHourInt, finalHourInt, timezone, _temp9) {
    if (timezone === void 0) {
      timezone = 'UTC';
    }

    var _ref9 = _temp9 === void 0 ? {} : _temp9,
        _ref9$rate = _ref9.rate,
        rate = _ref9$rate === void 0 ? 30 : _ref9$rate,
        format = _ref9.format,
        _ref9$onlyFuture = _ref9.onlyFuture,
        onlyFuture = _ref9$onlyFuture === void 0 ? false : _ref9$onlyFuture,
        _ref9$referenceDate = _ref9.referenceDate,
        referenceDate = _ref9$referenceDate === void 0 ? new Date() : _ref9$referenceDate;

    var intervals = [];
    if (!_isNumber(startHourInt) || !_isNumber(finalHourInt) || !timezone) return intervals;
    var nowDate = this.getTimezoneAwareNow(timezone);
    var currentDate = this.parseHourInt(startHourInt, {
      referenceDate: referenceDate
    });
    var startDate = this.parseHourInt(startHourInt, {
      referenceDate: referenceDate
    });
    var finalDate = this.parseHourInt(finalHourInt, {
      referenceDate: referenceDate
    });

    if (finalDate <= startDate) {
      finalDate = _addDays(finalDate, 1);
    }

    currentDate.setMinutes(0);

    while (currentDate < finalDate) {
      if (currentDate >= startDate && (currentDate > nowDate || !onlyFuture)) {
        var formattedDate = this.format(currentDate, format);
        intervals.push(formattedDate);
      }

      currentDate = addMinutes(currentDate, rate);
    }

    return intervals;
  }
};
export default DateUtils;